
import React from "react";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { LegalAssistanceSheet } from "./LegalAssistanceSheet";
import { Scale, Users, FileCheck } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { useTranslation } from "react-i18next";

export const LegalServicesBanner = () => {
  const {
    t
  } = useTranslation('legal');
  return <Card className="bg-gray-50/80 border-gray-100 shadow-sm hover:shadow transition-shadow duration-300">
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between">
          <div>
            
            <CardTitle className="mt-2 text-xl text-gray-800">{t('legalAssistance')}</CardTitle>
            <CardDescription className="text-gray-500 text-sm">
              {t('paidServiceDescription')}
            </CardDescription>
          </div>
          <div className="hidden md:flex h-10 w-10 rounded-full bg-primary-100 items-center justify-center">
            <Scale className="h-5 w-5 text-primary-600" />
          </div>
        </div>
      </CardHeader>
      <CardContent className="pb-2">
        <div className="grid gap-3 md:grid-cols-2">
          <div className="flex gap-2 items-start">
            <FileCheck className="h-4 w-4 text-primary-500 mt-0.5" />
            <div>
              <h4 className="text-sm font-medium text-gray-700">{t('documentReview')}</h4>
              <p className="text-xs text-muted-foreground">{t('documentReviewDesc')}</p>
            </div>
          </div>
          <div className="flex gap-2 items-start">
            <Users className="h-4 w-4 text-primary-500 mt-0.5" />
            <div>
              <h4 className="text-sm font-medium text-gray-700">{t('consultation')}</h4>
              <p className="text-xs text-muted-foreground">{t('consultationDesc')}</p>
            </div>
          </div>
        </div>
      </CardContent>
      <CardFooter className="flex justify-end items-center pt-2">
        <LegalAssistanceSheet />
      </CardFooter>
    </Card>;
};
